(function () {
  'use strict';

  var BRREG_API = 'https://data.brreg.no/enhetsregisteret/api/enheter/';
  var DEBOUNCE_MS = 600;

  function init() {
    var wrapperEl = document.querySelector('[data-bedrift-signup-fields]');
    if (!wrapperEl) return;

    var wrapper = wrapperEl.querySelector('[data-orgnr-wrapper]');
    var input = wrapperEl.querySelector('[data-orgnr-input]');
    var statusEl = wrapperEl.querySelector('[data-orgnr-status]');
    var messageEl = wrapperEl.querySelector('[data-orgnr-message]');
    var companyInput = wrapperEl.querySelector('[data-company-name-input]');

    if (!input || !companyInput) return;

    var customerId = wrapperEl.dataset.customerId;
    var customerEmail = wrapperEl.dataset.customerEmail;
    var apiUrl = wrapperEl.dataset.apiUrl;
    var form = wrapperEl.closest('form');
    var validOrgnr = null;
    var validCompany = null;

    var i18n = {
      validating: wrapperEl.dataset.i18nValidating,
      invalidDigits: wrapperEl.dataset.i18nInvalidDigits,
      invalidLength: wrapperEl.dataset.i18nInvalidLength,
      notFound: wrapperEl.dataset.i18nNotFound,
      deleted: wrapperEl.dataset.i18nDeleted,
      error: wrapperEl.dataset.i18nError,
      valid: wrapperEl.dataset.i18nValid
    };

    var timer = null;
    input.required = true;
    input.setCustomValidity(i18n.validating || ' ');

    function setStatus(status, message) {
      if (wrapper) wrapper.dataset.status = status;
      if (statusEl) statusEl.dataset.status = status;
      if (messageEl) messageEl.textContent = message || '';
    }

    function markPending() {
      validOrgnr = null;
      validCompany = null;
      companyInput.value = '';
      setStatus('', '');
      input.setCustomValidity(i18n.validating || ' ');
    }

    function submitApplication() {
      if (!apiUrl || !customerId || !validOrgnr || !validCompany) return;

      fetch(apiUrl.replace(/\/$/, '') + '/api/apply', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          customerId: customerId,
          customerEmail: customerEmail,
          orgnr: validOrgnr,
          company: validCompany
        })
      }).catch(function (err) {
        console.error('[bedrift-signup] apply request failed', err);
      });
    }

    function onInput() {
      var raw = input.value.replace(/[\s-]/g, '');
      clearTimeout(timer);
      markPending();

      if (!raw) return;

      if (!/^\d+$/.test(raw)) {
        setStatus('invalid', i18n.invalidDigits);
        return;
      }

      if (raw.length < 9) return;

      if (raw.length > 9) {
        setStatus('invalid', i18n.invalidLength);
        return;
      }

      setStatus('loading', i18n.validating);
      timer = setTimeout(function () {
        validate(raw);
      }, DEBOUNCE_MS);
    }

    function validate(orgnr) {
      fetch(BRREG_API + orgnr, { headers: { Accept: 'application/json' } })
        .then(function (res) {
          if (res.status === 404) {
            setStatus('invalid', i18n.notFound);
            return null;
          }
          if (!res.ok) {
            setStatus('error', i18n.error);
            return null;
          }
          return res.json();
        })
        .then(function (data) {
          if (!data) return;
          if (data.slettedato) {
            setStatus('invalid', i18n.deleted);
            return;
          }
          companyInput.value = data.navn;
          validOrgnr = orgnr;
          validCompany = data.navn;
          setStatus('valid', i18n.valid);
          input.setCustomValidity('');
        })
        .catch(function (err) {
          setStatus('error', i18n.error);
          console.error('[bedrift-signup]', err);
        });
    }

    input.addEventListener('input', onInput);
    if (form) form.addEventListener('submit', submitApplication);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
